<template>
  <button
    class="tw-border-none tw-bg-transparent tw-group tw-flex tw-items-center tw-gap-2"
    :data-test="dataTest"
    type="button">
    <div
      v-if="text"
      class="tw-text-sm tw-uppercase tw-font-bold tw-text-primary-400 group-hover:tw-text-primary-600 group-active:tw-text-primary-600 tw-tracking-widest"
      v-text="text" />
    <div class="tw-relative">
      <RoundIconButton
        :outlined="props.outlined"
        :disabled="props.disabled"
        :fa-icon="props.iconInner"
        :tooltip-text="props.tooltipText || ''"
        :tooltip-position="props.tooltipPosition" />
      <div
        v-if="props.iconOuter"
        class="tw-w-4 tw-h-4 tw-absolute tw-right-0 tw-top-0 tw-rounded-full tw-flex"
        :class="{
          'tw-bg-primary-200 tw-text-gray-100': props.disabled,
          'tw-bg-primary-300 tw-text-white': !props.disabled,
        }">
        <font-awesome-icon
          class="tw-m-auto"
          size="2xs"
          :icon="props.iconOuter" />
      </div>
    </div>
  </button>
</template>

<script setup lang="ts">
import type { PropType } from "vue";
import RoundIconButton from "../RoundIconButton/RoundIconButton.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

const props = defineProps({
  iconInner: {
    type: String,
    required: true,
  },
  iconOuter: {
    type: String,
    default: "",
  },
  text: {
    type: String,
    default: "",
  },
  outlined: {
    type: Boolean,
    default: true,
  },
  dataTest: {
    type: String,
    default: "",
  },
  tooltipText: {
    type: String,
    default: "",
  },
  tooltipPosition: {
    type: String as PropType<"top" | "bottom" | "left" | "right">,
    default: "bottom",
  },
  disabled: {
    type: Boolean,
  },
});
</script>